<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} traspaso
            <span *ngIf="isEdit">| {{item.value.code}}</span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="form-group col-lg-12">
                  <label>Búsqueda de reserva <span class="required"></span>
                    <ng-container *ngIf="bookingSelected != null">
                      <span class="m-l-15 bold">({{bookingSelected.code}})</span>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="bookingSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{bookingSelected.client_data.fullname}}- DOC:{{bookingSelected.client_data.document}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removeBookings()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="bookingSelected == null">
                    <component-search-bookings [classSize]="'search-small'"
                      (selectedBookingsEvent)="selectedBookingsSearch($event)" class="w-100">
                    </component-search-bookings>
                  </ng-container>
                </div>
                <div class="form-group col-lg-12 m-b-0">
                  <div *ngIf="bookingSelected != null">
                    <label><i class="fas fa-info-circle m-r-5"></i>Datos de la reserva:</label>
                    <div class="col-12">
                      <p class="m-b-4"><span class="bold m-r-5">N° pax:</span>{{bookingSelected.nro_pax}}</p>
                      <p class="m-b-4"><span class="bold m-r-5">Cel :</span>{{bookingSelected.client_data.cellphone}} -
                        {{bookingSelected.client_data.telephone}}</p>
                      <!-- <p class="m-b-4"><span class="bold m-r-5">Hotel: 
                        <span *ngFor="let hotel of bookingSelected.hotels_booking">{{hotel.tradename}}, </span></span></p> -->
                      <p class="m-b-4"><span class="bold m-r-5">Referencia ubicación
                          :</span>{{bookingSelected.reference_location}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="form-group col-lg-12">
                  <label>Agencia operadora<span class="required"></span>
                    <ng-container *ngIf="agencySelected != null">
                      <span class="m-l-15 bold"><i class="fas fa-phone m-r-5"></i>{{agencySelected.cellphone}}</span>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="agencySelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{agencySelected.tradename}}-{{agencySelected.document_str}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          uib-tooltip="Quitar" (click)="removeAgencies()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="agencySelected == null">
                    <component-search-agencies [classSize]="'search-small'"
                      (selectedAgenciesEvent)="selectedAgenciesSearch($event)" class="w-100">
                    </component-search-agencies>
                  </ng-container>
                </div>
                <div class="form-group col-lg-12">
                  <label>Observaciones</label>
                  <textarea formControlName="observations" class="form-control no-resize" rows="2"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-12 m-t-10 form__contentTbl">
              <div class="table-responsive">
                <table class="table mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th *ngIf="!isEdit" class="w-5"></th>
                      <th class="text-center">N° PAX</th>
                      <th>Nombre tours</th>
                      <th>Vehículo</th>
                      <th>Turno</th>
                      <th>Fecha asignada</th>
                      <th class="w-15 text-right">Precio corporativo</th>
                      <th class="w-15 text-right">Cobranza delegada
                        <i class="fas fa-info-circle m-l-5"
                          uib-tooltip="Si hay alguna cobranza delegada al operador, importante! en el cuadre de agencias"></i>
                      </th>
                      <!-- <th class="w-15 text-center">
                        Observación
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7">
                          <span><i class="m-r-5"></i>Debe seleccionar el tours para cargar los pasajeros de la reservas
                            pendientes.</span>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <tr *ngFor="let item of bookings; let index_ = index">
                        <td class="w-5" *ngIf="!isEdit">
                          <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="booking_{{item.id}}"
                              (change)="selectedBooking(item, index_)">
                            <label class="custom-control-label p-t-3" for="booking_{{item.id}}"></label>
                          </div>
                        </td>
                        <td class="text-center">
                          {{item.quantity}}
                        </td>
                        <td >
                          {{item.description}}
                        </td>
                        <td>
                          <span
                            class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                        </td>
                        <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                        <td>
                          {{item.date_assigned}}
                        </td>
                        <td class="w-15">
                          <div class="input-group">
                            <span class="input-group-prepend"><span class="input-group-text"
                                style="padding: 2px 9px;">S/</span></span>
                            <input type="text" id="tours_pricecorporate{{index_}}" value="{{item.price_corporate}}"
                              numeric decimals="2" (keyup)="changePriceCorporate($event.target, item)"
                              onclick="click_input(this)" class="form-control sale__input text-right" [disabled]="!item.is_selected || item.is_paid">
                          </div>
                        </td>
                        <td class="w-15">
                          <div class="input-group">
                            <span class="input-group-prepend"><span class="input-group-text"
                                style="padding: 2px 9px;">S/</span></span>
                            <input type="text" id="tours_delegatedpayment{{index_}}" value="{{item.delegated_payment}}"
                              numeric decimals="2" (keyup)="changeDelegatedPayment($event.target, item)"
                              onclick="click_input(this)" class="form-control sale__input text-right" [disabled]="!item.is_selected || item.is_paid">
                          </div>
                        </td>
                        <!-- <td class="w-15">
                          <input type="text" id="tours_observation{{index_}}" value="{{item.observation}}"
                            (keyup)="changeObservation($event.target, item)"
                            class="form-control sale__input text-center" [disabled]="!item.is_selected">
                        </td> -->
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar Traspaso
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
